import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { TICKET_REQUIRED_EVENT, type TicketRequest } from "@/lib/guest";

/**
 * Global seat router. Guests browse the real theatre; the moment they try to
 * use a feature, `requestTicket()` fires and they land on the sign-in / sign-up
 * page with a note about what they were reaching for.
 */
export const SeatPrompt = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (event: Event) => {
      const detail = (event as CustomEvent<TicketRequest>).detail;
      navigate("/auth", { state: { intent: detail?.action } });
    };
    window.addEventListener(TICKET_REQUIRED_EVENT, handler);
    return () => window.removeEventListener(TICKET_REQUIRED_EVENT, handler);
  }, [navigate]);

  return null;
};

export default SeatPrompt;
